import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=497f5fcc&scoped=true"
var script = {}
import style0 from "./NoResult.vue?vue&type=style&index=0&id=497f5fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f5fcc",
  null
  
)

export default component.exports